import api from '@/services/api';

const ContractPartyMasterUpdate = {
  updateContractPartyMaster: (contractPartyMasterId, contractPartyName) => {
    return api.post('update_contract_party_master/', {
      contract_party_master_id: contractPartyMasterId,
      contract_party_name: contractPartyName
    });
  },
  deleteContractPartyMaster: contractPartyMasterId => {
    return api.post('delete_contract_party_master/', {
      contract_party_master_id: contractPartyMasterId
    });
  }
};

export default ContractPartyMasterUpdate;



// WEBPACK FOOTER //
// ./src/api/user_contract/contract_party_master/update.js